var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssignedVouchersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 26.4494V24.7827H15.8333V10.5377L19.3333 14.0377L20.5133 12.8577L15 7.34602L9.48667 12.8577L10.6667 14.0377L14.1667 10.5377V18.4993H2.69167C1.925 18.4993 1.285 18.2427 0.771667 17.7293C0.257222 17.2149 0 16.5744 0 15.8077V2.85768C0 2.09102 0.257222 1.45102 0.771667 0.937682C1.285 0.423238 1.925 0.166016 2.69167 0.166016H27.3083C28.075 0.166016 28.715 0.423238 29.2283 0.937682C29.7428 1.45102 30 2.09102 30 2.85768V15.8077C30 16.5744 29.7433 17.2149 29.23 17.7293C28.7156 18.2427 28.075 18.4993 27.3083 18.4993H17.5V24.7827H23.3333V26.4494H6.66667Z",
    fill: "#558223"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignedVouchersIcon);
export default __webpack_public_path__ + "static/media/assignedVouchersIcon.7849ec33acd06796c3f2f1d077a23126.svg";
export { ForwardRef as ReactComponent };